import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { H1 } from '~COMPONENTS/containers/Headers';
import Link from '../../components/Link';
import P from '~COMPONENTS/containers/Paragraph';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { userResetEmail } from '../reducer';

export const EmailSent = ({ type, userResetEmail, isModal }) => (
  <div className='ta-sm-c' style={{ maxWidth: '338px' }}>
    <H1 className='mt6-sm'>Email Sent</H1>
    {type && type === 'password' ? (
      <div className='body-4'>
        <P className='pt7-sm pb10-sm'>
          <TranslatedCopy id='login.password.reset.sent.body' values={{ email: userResetEmail }} />
        </P>
      </div>
    ) : (
      <div className='body-4 pt5-sm pb8-sm'>
        <p className='pb3-sm'>
          <TranslatedCopy id='migrate.user.recoverUser.sent.body' />
        </p>
      </div>
    )}

    {!isModal && (
      <Link to='/login' className='ncss-btn-primary-dark u-full-width' data-desc='emailSent__link_login'>
        <TranslatedCopy id='login.return' />
      </Link>
    )}
  </div>
);

EmailSent.defaultProps = {
  type: null,
  userResetEmail: null,
  isModal: false
};

EmailSent.propTypes = {
  type: PropTypes.string,
  userResetEmail: PropTypes.string,
  isModal: PropTypes.bool
};

const mapStateToProps = state => ({
  userResetEmail: userResetEmail(state)
});

const connector = connect(mapStateToProps, {});

export default connector(EmailSent);
